import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getTeacherBaselineThunk = createAsyncThunk(
  "teacherexam/get",
  async (params) => {
    const { usertype } = params;
    let response = await api.get("getAllTchBaselineCategories/" + usertype);
    return response.data;
  }
);

export const createTeacherBaselineThunk = createAsyncThunk(
  "teacherexam/create",
  async (body) => {
    let response = await api.post("createTchBaselineCategory", body);
    return response.data;
  }
);

export const updateTeacherBaselineThunk = createAsyncThunk(
  "teacherexam/update",
  async (reqbody) => {
    const id = reqbody._id;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body

    let response = await api.put("updateTchBaselineCategory/" + id, body.body);
    return response.data;
  }
);

export const deleteTeacherBaselineThunk = createAsyncThunk(
  "teacherexam/delete",
  async (id) => {
    let response = await api.delete("deleteTchBaselineCategory/" + id);
    return response.data;
  }
);
